import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import type {
  OnlineOfflineUserStatus as DatastoreOnlineOfflineStatusObject,
  OnlineOfflineStatus,
} from '@freelancer/datastore/collections';
import { OnlineOfflineStatusApi } from 'api-typings/users/users';

@Pipe({ standalone: false, name: 'onlineOfflineStatus' })
export class OnlineOfflineStatusPipe implements PipeTransform {
  transform(
    user?: { id: number; onlineOfflineStatus?: OnlineOfflineStatus },
    onlineOfflineStatuses?: readonly DatastoreOnlineOfflineStatusObject[],
  ): OnlineOfflineStatus | undefined {
    if (!user) {
      return;
    }

    const matchingStatus = onlineOfflineStatuses?.find(
      status => status.id === user.id,
    );

    if (!matchingStatus) {
      return {
        status:
          user.onlineOfflineStatus?.status ?? OnlineOfflineStatusApi.OFFLINE,
        lastUpdatedTimestamp: user.onlineOfflineStatus?.lastUpdatedTimestamp,
      };
    }

    return {
      status: matchingStatus.status,
      lastUpdatedTimestamp:
        matchingStatus.lastUpdatedTimestamp ??
        user.onlineOfflineStatus?.lastUpdatedTimestamp,
    };
  }
}
